import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getCurrentUserRole, isCompanyPrivileged } from "../utils/roleUtils";
import { roleType } from "../constant/constants";
import { useSelector } from "react-redux";

const NotFoundRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRole = getCurrentUserRole();
  const [redirectMessage, setRedirectMessage] = useState("");
     const { configData } = useSelector((state) => state.config);
    // Check if training needs workflow is enabled
  const isTrainingWorkflowEnabled = configData?.training_need_workflow ?? false;

  useEffect(() => {
    // Determine the appropriate redirect destination and message
    let redirectPath = "";
    let message = "";

    switch (currentRole) {
      case roleType.ADMIN:
        redirectPath = "/company-list";
        message = "Redirecting you to Companies page...";
        break;
      case roleType.COMPANY_ADMIN:
      case roleType.SDF:
        if(!isTrainingWorkflowEnabled){
          redirectPath= "/employee-list";
          message= "Redirecting you to employee..."
        }
        else{

          redirectPath =   "/dashboard";
          message = "Redirecting you to Dashboard...";
          
        }
        break;
      case roleType.MANAGER:
        redirectPath = "/dashboard";
        message = "Redirecting you to Dashboard...";
        break;
      case roleType.EMPLOYEE:
        redirectPath = "/employee-form-status";
        message = "Redirecting you to Training Needs Form Status...";
        break;
      default:
        redirectPath = "/";
        message = "Redirecting you to Login...";
        break;
    }

    setRedirectMessage(message);

    // Add a small delay to show the message before redirecting
    const timer = setTimeout(() => {
      navigate(redirectPath, { replace: true });
    }, 5000);

    return () => clearTimeout(timer);
  }, [currentRole, navigate, isTrainingWorkflowEnabled]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
        <div className="mb-4">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Access Denied</h2>
        <p className="text-gray-600 mb-4">
          You don't have permission to access this page or the page doesn't exist.
        </p>
        <p className="text-sm text-gray-500 mb-4">
          Attempted to access: <span className="font-mono bg-gray-100 px-2 py-1 rounded">{location.pathname}</span>
        </p>
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
          <p className="text-blue-600">{redirectMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundRedirect; 